import { useTranslation } from 'react-i18next'

import Button from '../../Button'
import { Divider } from '../../Divider'
import { useSelectContext } from '../../Select'

import { QA_NAME_LABEL_SELECT_DROPDOWN_LIST_FOOTER_ADD_NEW_LABEL_BTN } from './LabelSelectDropdownListFooter.constants'

import * as styles from './LabelSelectDropdownListFooter.module.css'

import PlusIcon from '../../../icons/plus.svg'

function LabelSelectDropdownListFooter({
  Element = 'div',
  className = styles.LabelSelectDropdownListFooter,
  onAddNewLabel,
}) {
  const { t } = useTranslation()

  const { handleClose } = useSelectContext()

  function handleAddNewLabel(event) {
    onAddNewLabel(event)

    handleClose()
  }

  return (
    <Element className={className}>
      <Divider />
      <Button.Text
        beforeIconProps={{ Icon: PlusIcon }}
        className={styles.addNewLabelButton}
        qaName={QA_NAME_LABEL_SELECT_DROPDOWN_LIST_FOOTER_ADD_NEW_LABEL_BTN}
        text={t('Label.SelectDropdownAddNewLabelBtnKey')}
        onClick={handleAddNewLabel}
      />
    </Element>
  )
}

export default LabelSelectDropdownListFooter
